module.exports = __webpack_public_path__ + "img/search-placeholder.6e04c2cb.svg";